import { render, staticRenderFns } from "./ContactCardDetails.vue?vue&type=template&id=998d6966"
import script from "./ContactCardDetails.vue?vue&type=script&lang=js"
export * from "./ContactCardDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports